import { useNavigate, useLocation } from "react-router-dom";

import Header from "../header/header";
import FooterButton from "../footer/footerButton.js";

import "./moving.css";

export default function Moving() {
  const navigate = useNavigate();
  const location = useLocation();

  const state = location.state || {};
  const { DateVal, userRole, introInCodeV } = state;

  const handleButtonClick = async () => {
    navigate("/answer", {
      state: {
        DateVal: "tutorialExp",
        titImgClass: "tutorialExp1Tit",
        counting: false,
      },
    });
  };

  return (
    <div id="content" className="">
      <Header />

      <div className="boxPop content_box1">
        <div className="box_con con_box_moving con_pd9 ">
          <div className="missionDiv">
            <div className="missionDi">
              <div className="mission_tit movingTit"></div>
              <div className="moving_text mt16">
                ‘갤럭시 AI 비밀본부’에
                <br />
                오신 것을 환영합니다.
              </div>
            </div>
          </div>

          <FooterButton
            ftIdName="box_ft"
            buttonClass="inputBtn02"
            buttonValue="이동 완료"
            onFinish={handleButtonClick}
          />
        </div>
      </div>
    </div>
  );
}
